/// 顶部 --- 统计数据
export const totalConfig = {
  "MN专营台数": "25719",
  "YL专营台数": "14462",
  "JLB专营台数":"8562",
  
  "QT专营台数": "704",
}

/// ----
export const tableDataArr1 = {
  "product": ["07-01","07-02","07-03","07-04","07-05","07-06","07-07","07-08"],
    "MN专营台数": [551,381,452,262,527,443,374,618],
    "YL专营台数": [485,307,365,387,361,385,496,392],
    "JLB专营台数": [262,129,210,225,187,190,210,470],
    "QT专营台数": [316,176,235,244,254,248,176,261]   
}
export const tableDataArr2 = 
  {
    "MN专营台数": [1089,4746,1707,2800,2042,2055,1238,1547,990,2263,2494,2302],
    "product": ["北京","东北","华北","华东","华南","华中","闽赣","山东","上海","西北","西南","豫皖"],
    "YL专营台数": [917,2779,1341,1497,1053,1180,843,522,566,1456,1259,817],
    "JLB专营台数": [614,1917,1650,790,40,306,313,852,728,440,102,799],
    "QT专营台数": [50,16,19,129,70,102,36,32,143,14,10,77]
  }

export const tableDimensionArr = ["product", "MN专营台数", "YL专营台数", "JLB专营台数", "QT专营台数"]

///
export const modernChartDataArr = [
  {
    "type": "bar",
    "stack": "vistors",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "bar",
    "stack": "vistors",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "bar",
    "stack": "vistors",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
  {
    "type": "bar",
    "stack": "vistors",
    "barWidth": "70%",
    "label": {
      "normal": {
        "show": true,
        "color": "black",
        "fontSize": 10,
        "position": "inside"
      }
    },
    "animationDuration": 2800,
    "animationEasing": "cubicInOut"
  },
]





// WEBPACK FOOTER //
// ./src/components/kpi/config/TwentyStock.js